import React from "react";
import { Box, Text, Image } from "@chakra-ui/react";
import useIsMobile from "../Hooks/useIsMobile";

const TUTORIAL_CONTENT = {
    step1: {
        character: "/images/enzedion.png",
        text: "First, Select the size of your room. But be careful, this cannot be changed later"
    },
    step2: {
        character: "/images/cubeguy.png",
        text: "Select your wall type. Choose between basic colors or animated wallpapers for your room"
    },
    step2b: {
        character: "/images/cubeguy.png",
        text: "Add wall decorations. This is where you can add your artwork, videos, links to social media and more to your room"
    },
    step3: {
        character: "/images/mogulplex-image.png",
        text: "Finally, add your 3D room decorations to make your room a true 3D experience"
    }
};

const TutorialOverlay = ({ currentStep, onComplete, onSkip, isVisible }) => {
    const tutorial = TUTORIAL_CONTENT[currentStep];
    const isMobile = useIsMobile();

    if (!isVisible || !tutorial) return null;

    const handleDismiss = () => {
        onComplete();
    };

    return (
        <Box
            position="fixed"
            top={0}
            left={0}
            right={0}
            bottom={0}
            bg="blackAlpha.600"
            zIndex={20000}
            onClick={handleDismiss}
            cursor="pointer"
        >
            {/* Character Image */}
            <Image
                src={tutorial.character}
                alt="Tutorial Character"
                position="absolute"
                top={currentStep === "step3" ? (isMobile ? "-15%" : "-20%") : (isMobile ? "-10%" : "0%")}
                left="10%"
                width="700px"
                height="700px"
                objectFit="contain"
                pointerEvents="none"
            />

            {/* Text Box */}
            <Box
                position="absolute"
                top={isMobile ? "65%" : "60%"}
                left="50%"
                transform="translate(-50%, -50%)"
                maxW="600px"
                w="90%"
                onClick={(e) => e.stopPropagation()}
            >
                <Box
                    bg="black"
                    border="3px solid white"
                    p={6}
                    w="full"
                    minH="160px"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                >
                    <Text
                        fontSize="18px"
                        color="white"
                        fontFamily="'DM Mono', monospace"
                        lineHeight="1.6"
                    >
                        {tutorial.text}
                    </Text>
                </Box>

                <Text
                    fontSize="16px"
                    color="white"
                    textAlign="center"
                    cursor="pointer"
                    onClick={handleDismiss}
                    _hover={{ opacity: 0.8 }}
                    fontFamily="'DM Mono', monospace"
                    mt={3}
                >
                    Click to dismiss
                </Text>
            </Box>
        </Box>
    );
};

export default TutorialOverlay;
